import React from 'react';
import moment from 'jalali-moment';

/*
    - ihoDesignSystem
*/
import { Badge, Box, Button, Grid, Image, Typography } from '@iho-design-system/Loader';

/*
    - svg
*/
import ObserverSVG from '../../assets/images/icons/observer.svg';
import EmptySVG from '../../assets/images/icons/empty.svg';
import PaginationRightSVG from '../../assets/images/icons/pagination-right.svg';
import PaginationLeftSVG from '../../assets/images/icons/pagination-left.svg';
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';

const List = ({ props, selectedRequestProps, paginationProps }) => {

    /*
        defaultData
    */
    const [userTicketsResult, setUserTicketsResult] = React.useState('loading');

    React.useEffect(() => {
        if (props.userTickets !== '') {
            if (props.userTickets.status === 200 && props.userTickets.data.Data.length > 0) {
                setUserTicketsResult(props.userTickets.data);
            } else {
                setUserTicketsResult('empty');
            }
        }
    }, [props]);

    if (userTicketsResult === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (userTicketsResult === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`my-xxl mb-0 mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block my-md text-center`}
                        component='h2'>
                        لیست درخواست‌های شما خالی است :(
                    </Typography>
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                        هیچ رزروی یافت نشد!
                    </Typography>
                </Box>
            </React.Fragment>
        )
    }

    if (userTicketsResult !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            size='col-12'>
                            <Box
                                ms={{
                                    '@media(max-width:992px)': {
                                        overflowX: 'scroll'
                                    }
                                }}>
                                <Box
                                    ms={{
                                        minWidth: '992px'
                                    }}>
                                    <Box
                                        className={`d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--gray-light)'
                                        }}>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '14.2857%'
                                            }}>
                                            <Typography>
                                                کد درخواست
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '14.2857%'
                                            }}>
                                            <Typography>
                                                نوع درخواست
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '14.2857%'
                                            }}>
                                            <Typography>
                                                تاریخ ثبت
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '14.2857%'
                                            }}>
                                            زمان ثبت
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '14.2857%'
                                            }}>
                                            وضعیت
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '14.2857%'
                                            }}>
                                            کد پیگیری رزرو
                                        </Box>
                                        <Box
                                            ms={{
                                                width: '14.2857%'
                                            }} />
                                    </Box>
                                    <Box
                                        className={`border-solid border-light rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--white)'
                                        }}>
                                        {userTicketsResult.Data.map((obj, index) => {
                                            return (
                                                <Box
                                                    key={index}>
                                                    <Box
                                                        className={`d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                        <Box
                                                            ms={{
                                                                width: '14.2857%'
                                                            }}>
                                                            {obj.Id}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '14.2857%'
                                                            }}>
                                                            {obj.Title.substring(8)}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '14.2857%',
                                                                whiteSpace: 'nowrap'
                                                            }}>
                                                            {moment.from(obj.AddDate.split('T')[0]).locale('fa').format('YYYY-MM-DD')}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '14.2857%'
                                                            }}>
                                                            {obj.AddDate.split('T')[1].split('.')[0]}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '14.2857%'
                                                            }}>
                                                            {obj.Status === 0 &&
                                                                <Badge
                                                                    color='light'
                                                                    ms={{
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                    {obj.StatusTitle}
                                                                </Badge>
                                                            }
                                                            {obj.Status === 1 &&
                                                                <Badge
                                                                    color='success'
                                                                    ms={{
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                    {obj.StatusTitle}
                                                                </Badge>
                                                            }
                                                            {obj.Status === 2 &&
                                                                <Badge
                                                                    color='warning'
                                                                    ms={{
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                    {obj.StatusTitle}
                                                                </Badge>
                                                            }
                                                            {obj.Status === 3 &&
                                                                <Badge
                                                                    color='danger'
                                                                    ms={{
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                    {obj.StatusTitle}
                                                                </Badge>
                                                            }
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '14.2857%'
                                                            }}>
                                                            {obj.ReserveId}
                                                        </Box>
                                                        <Box
                                                            className={`d-flex align-item-center justify-content-end`}
                                                            ms={{
                                                                width: '14.2857%'
                                                            }}>
                                                            <Image
                                                                onClick={() => selectedRequestProps(obj)}
                                                                className={`pointer`}
                                                                src={ObserverSVG}
                                                                ms={{
                                                                    width: '16px',
                                                                    height: '16px'
                                                                }} />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                        <Box
                                            className={`d-flex justify-content-center rounded-sm rounded-top-right-0 rounded-top-left-0`}
                                            ms={{
                                                height: '56px',
                                                backgroundColor: 'var(--gray-ultra-light)'
                                            }}>
                                            <Box
                                                className={`d-flex justify-content-center align-item-center`}
                                                ms={{
                                                    gap: '16px'
                                                }}>
                                                <Button
                                                    onClick={() => paginationProps(-1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationRightSVG} />
                                                </Button>
                                                <Typography
                                                    className={`text-primary`}>
                                                    {userTicketsResult.PageIndex} / {Math.ceil(userTicketsResult.TotalItems / userTicketsResult.PageSize)}
                                                </Typography>
                                                <Button
                                                    onClick={() => paginationProps(1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationLeftSVG} />
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </React.Fragment >
        );
    }

}

export default List;